export default "__VITE_ASSET__D6isjdU0__"